<script lang="ts">
    import { differenceInCalendarDays, differenceInHours, format, startOfDay } from "date-fns";
    import { onDestroy } from "svelte";

    /** First day of the forecast plan (start of day, in the user's calendar) */
    export let startDate: Date

    let now = new Date()
    const timer = setInterval(() => now = new Date(), 60*1000)
    onDestroy(() => clearInterval(timer))

    $: hoursLeft = differenceInHours(startOfDay(startDate), now)
    $: daysLeft = differenceInCalendarDays(startDate, now)
    $: countdown = hoursLeft < 24
        ? `${Math.max(hoursLeft, 0)} ${hoursLeft === 1 ? 'hour' : 'hours'}`
        : `${daysLeft} ${daysLeft === 1 ? 'day' : 'days'}`
</script>

<div class="pre-plan-banner flex flex-col gap-1 items-center text-center border border-solid rounded border-xerteal-600/30 bg-xerteal-600/5 px-5 py-4">
    <div class="font-bold text-lg"><i class="fa-regular fa-hourglass-half mr-2"/>Pre-Plan Maintenance Program</div>
    <div class="text-slate-600">Your plan starts on <span class="font-bold">{format(startDate, 'EEEE do MMMM yyyy')}</span></div>
    <div class="text-2xl font-bold text-xerteal-700">Starts in {countdown}</div>
    <div class="text-slate-500 text-sm">Until then, Xert maintains your current fitness with Adaptive Training Advisor recommendations.</div>
</div>
